export const GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST = 'GET_CHANGE_MOBILE_CARD_PROFILE_REQUEST';
export const GET_CHANGE_MOBILE_CARD_PROFILE_SUCCESS = 'GET_CHANGE_MOBILE_CARD_PROFILE_SUCCESS';
export const GET_CHANGE_MOBILE_CARD_PROFILE_FAILURE = 'GET_CHANGE_MOBILE_CARD_PROFILE_FAILURE';

export const GET_EXISTING_MOBILE_REQUEST = 'GET_EXISTING_MOBILE_REQUEST';
export const GET_EXISTING_MOBILE_SUCCESS = 'GET_EXISTING_MOBILE_SUCCESS';
export const GET_EXISTING_MOBILE_FAILURE = 'GET_EXISTING_MOBILE_FAILURE';
